import React from 'react';
import styles from './Footer.module.css';
import logoEnergy5Negative1 from 'assets/lp/logoenergy5.png'

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerWrapper}>
        <div className={styles.logofooter}>
          <img src={logoEnergy5Negative1} alt="Logo Energy5" />
        </div>
        <div className={styles.col3}>
          <p className={styles.footertext}>
            Energy5 EV Charging solutions comprise a full range of end-to-end turnkey services for businesses. From permitting to incentive acquisition to installation, management software, and down-the-road maintenance, Energy5 streamlines the whole process every step of the way.
          </p>
        </div>
        <div className={styles.col3}>
          <p className={styles.footertext}>
            <b>Address</b><br />
            300 W Somerdale Rd, Suite 5, Voorhees Township, NJ 08043 <br />
            <b>Email address</b><br />
            hello@energy5.com<br />
            <b>Phone number</b><br />
            (856) 412-4400
          </p>
        </div>
        <div className={styles.col3}>
          <a href="/privacy" target="_blank" className={styles.footertext}>Privacy policy</a><br />
          <a href="/terms" target="_blank" className={styles.footertext}>Terms of use</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
